import { Injectable } from '@angular/core';
import { CancellationReasonEnum, SubscriptionCancellationCompetitorEnum } from '@rma/billing-api';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CancellationReasonService {
  public cancellationReason$: Observable<CancellationReasonEnum>;
  public cancellationFeedback$: Observable<string>;
  public cancellationCompetitor$: Observable<SubscriptionCancellationCompetitorEnum | undefined>;
  public otherTool$: Observable<string | undefined>;

  private cancellationReason = new ReplaySubject<CancellationReasonEnum>(1);
  private cancellationFeedback = new ReplaySubject<string>(1);
  private cancellationCompetitor = new ReplaySubject<SubscriptionCancellationCompetitorEnum | undefined>(1);
  private otherTool = new ReplaySubject<string | undefined>(1);

  constructor() {
    this.cancellationReason.next(CancellationReasonEnum.NoAnswer);
    this.cancellationFeedback.next('');
    this.cancellationCompetitor.next(undefined);
    this.otherTool.next(undefined);

    this.cancellationFeedback$ = this.cancellationFeedback.asObservable();
    this.cancellationReason$ = this.cancellationReason.asObservable();
    this.cancellationCompetitor$ = this.cancellationCompetitor.asObservable();
    this.otherTool$ = this.otherTool.asObservable();
  }

  public setCancellationReason(reason: CancellationReasonEnum): void {
    this.cancellationReason.next(reason);
  }

  public setCancellationFeedback(feedback: string): void {
    this.cancellationFeedback.next(feedback);
  }

  public setCancellationCompetitor(competitor: SubscriptionCancellationCompetitorEnum): void {
    this.cancellationCompetitor.next(competitor);
    if (competitor !== SubscriptionCancellationCompetitorEnum.Other) {
      this.otherTool.next(undefined);
    }
  }

  public setOtherTool(otherTool: string): void {
    this.otherTool.next(otherTool);
  }
}
